import type { JSX } from 'react'

import { NavBarLogoSC } from './NavBar.styled'

export interface INavBarLogo {
  children: React.ReactNode
}

export const NavBarLogo = ({ children }: INavBarLogo): JSX.Element => {
  return <NavBarLogoSC>{children}</NavBarLogoSC>
}
